import React from 'react'
import uniqid from 'uniqid'

import { FormatDate } from '../utils'
import { withScroller } from '../utils/withScroller'

export type GridViewEntityItemProps = {
  orangeDisplay: boolean
  ratingActionDescription: string
  ratingAlertCode: string | null
  ratingAlertDescription: string
  ratingCode: string
  ratingEffectiveDate: string
  ratingTypeDescription: string
  sequenceNumber?: number
  correctionFlag: boolean
  ratingChangeDate: string
}

export type GridViewEntityProps = {
  items: GridViewEntityItemProps[]
}

const renderItem = ({
  orangeDisplay,
  ratingAlertCode,
  ratingActionDescription,
  ratingCode,
  ratingEffectiveDate,
  ratingTypeDescription,
  correctionFlag,
  ratingChangeDate
}: GridViewEntityItemProps) => (
  <tbody key={uniqid()}>
    <tr>
      <td className={orangeDisplay ? 'eu-rating-text' : ''}>
        {ratingCode}
        <span
          className={ratingAlertCode ? ratingAlertCode.replace(':', '') : ''}
        />
      </td>
      <td>{ratingActionDescription}</td>
      <td>{FormatDate(ratingEffectiveDate, 'dd MMM yyyy')}</td>
    </tr>
    <tr>
      <td colSpan={3}>
        <p className="ta--1">
          {ratingTypeDescription}
          {correctionFlag ? (
            <>
              <br />
              Rating Correction
              <br />
              {ratingChangeDate &&
                `(${FormatDate(ratingChangeDate, 'dd-MMM-yyyy')})`}
              <br />
            </>
          ) : null}
        </p>
      </td>
    </tr>
  </tbody>
)

export const GridViewEntity = (props: GridViewEntityProps) => {
  const { items } = props
  const showOneRating = items && items.length >= 1 ? renderItem(items[0]) : null

  return (
    <div className="table table--4">
      {withScroller(
        <table className="table__wrapper" style={{ width: '100%' }}>
          <colgroup>
            <col width="125px" />
            <col width="125px" />
            <col width="107px" />
          </colgroup>
          {showOneRating}
        </table>
      )}
      {items.length > 1 ? (
        <p style={{ fontSize: '12px' }}>Additional Ratings Available</p>
      ) : null}
    </div>
  )
}
